

import { Field, Input } from "@fluentui/react-components";
import { useState } from "react";

export interface IStringInputProps {
    value: string
    label: string;
    onValueChange(value: string): void;
    onIsValidChange(isValid: boolean): void;
}

export const StringInput = (props: IStringInputProps) => {
    const { value, label, onValueChange, onIsValidChange } = props;

    const [validationState, setValidationState] = useState<"none" | "success" | "error">("none");
    const [validationMessage, setValidationMessage] = useState("");

    const isValueValid = (newValue: string): boolean => {
        return !!newValue && newValue.trim() !== "";
    };

    const onValueChanged = (newValue: string) => {
        onValueChange(newValue);

        const isValueValidState = isValueValid(newValue);
        onIsValidChange(isValueValidState);

        setValidationState(isValueValidState ? "none" : "error");
        setValidationMessage(isValueValidState ? "" : "Please enter a valid string value.");
    };

    return (
        <Field required label={label} validationState={validationState} validationMessage={validationMessage}>
            <Input aria-label="string input" onChange={(_, data) => onValueChanged(data.value)} value={value} />
        </Field>
    );
};